import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';

function FeesList() {
  const [classes, setClasses] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

useEffect(() => {
  const fetchClasses = async () => {
    const sessionId = localStorage.getItem('currentSessionId');
    if (!sessionId) return;

    try {
      const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/feeStructures/getFeeStructures`, {
        params: { sessionId } 
      });
      setClasses(response.data);
    } catch (error) {
      console.error('Error fetching classes:', error);
      setError('Failed to load class data.');
    } finally {
      setLoading(false);
    }
  };

  fetchClasses();
}, []);



const handleDelete = async (classId) => {
  const confirmDelete = window.confirm('Are you sure you want to delete this fee structure?');
  if (!confirmDelete) return;

  try {
    const sessionId = localStorage.getItem('currentSessionId'); // get current session
    await axios.delete(
      `${process.env.REACT_APP_API_BASE_URL}/api/feeStructures/deleteFeeStructure/${classId}`,
      {
        params: { sessionId }, // ✅ send 
        headers: { Authorization: `Bearer ${localStorage.getItem("token")}` } // include token in headers
      },
      
    );

    setClasses(classes.filter((cls) => cls._id !== classId));
  } catch (error) {
    console.error('Error deleting class:', error);
    setError(error.response?.data?.message || 'Failed to delete class.');
  }
};


  if (loading) {
    return (
      <div className="w-full p-6 bg-white shadow-lg rounded-lg">
        <h1 className="text-2xl md:text-3xl font-extrabold text-gray-800 mb-6">Class Fee Structure</h1>
        <p>Loading...</p>
      </div>
    );
  }

  if (error) {
    return (
      <div className="w-full p-6 bg-white shadow-lg rounded-lg">
        <h1 className="text-2xl md:text-3xl font-extrabold text-gray-800 mb-6">Class Fee Structure</h1>
        <p className="text-red-500">{error}</p>
      </div>
    );
  }

  return (
    <div className="w-full p-4 sm:p-6 bg-white shadow-lg rounded-lg">
    
      <Link
        to="/fee-structure/new"
        className="inline-flex items-center px-4 py-2 bg-green-500 rounded-md text-white text-sm font-medium hover:bg-green-600 mb-4"
      >
        Add New Fee Structure
      </Link>

      {/* Responsive Table Container */}
      <div className="overflow-x-auto">
        <table className="min-w-full divide-y divide-gray-200">
          <thead className="bg-gray-50">        
            <tr>
              <th className="px-4 sm:px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">ID</th>
              <th className="px-4 sm:px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                Class
              </th>
              <th className="px-4 sm:px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                Student Type
              </th>
              <th className="px-4 sm:px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                Medium
              </th>
              <th className="px-4 sm:px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                Total Fees
              </th>
              <th className="px-4 sm:px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                Actions
              </th>
            </tr>
          </thead>

          <tbody className="bg-white divide-y divide-gray-200">
            {classes.map((cls) => (
              <tr key={cls._id}>
                <td className="px-4 py-4 text-sm text-blue-600 font-semibold">
                  {cls._id}
                </td>
                <td className="px-4 sm:px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">
                  {cls.class}
                </td>
                <td className="px-4 sm:px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                  {cls.studentType}
                </td>
                <td className="px-4 sm:px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                  {cls.medium}
                </td>
                <td className="px-4 sm:px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                  {cls.totalfees}
                </td>

                {/* Responsive Action Buttons */}
                <td className="px-4 sm:px-6 py-4 whitespace-nowrap text-sm font-medium">
                  <div className="flex flex-col sm:flex-row sm:items-center gap-2">
                    <Link
                      to={`/fee-structure/${cls._id}`}
                      className="px-4 py-2 bg-blue-700 rounded-md text-white hover:bg-blue-600 text-center"
                    >
                      Edit
                    </Link>

                    <button
                      onClick={() => handleDelete(cls._id)}
                      className="px-4 py-2 bg-red-600 rounded-md text-white hover:bg-red-400 text-center"
                    >
                      Delete
                    </button>
                  </div>
                </td>

              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default FeesList;
